<template>
  <div class="woori-crowdfunding">
    <!-- 히어로 섹션 -->
    <div class="hero-section">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center">
            <h1 class="text-h3 font-weight-bold mb-4">
              2025년 우리동네 크라우드 펀딩 (대출형)
            </h1>
            <p class="text-h6 mb-8">
              소상공인이 동네 주민(개인 투자자)에게<br>
              사업자금을 빌리고 이자를 상환하는 크라우드 펀딩
            </p>
            <v-btn
              color="primary"
              x-large
              class="apply-btn"
              @click="applyFunding"
            >
              펀딩 신청하기
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- 주요 혜택 섹션 -->
    <v-container class="benefits-section">
      <v-row align="stretch">
        <v-col cols="12" class="text-center mb-12">
          <h2 class="text-h4 font-weight-bold mb-4">우리동네 크라우드 펀딩만의 혜택!</h2>
          <p class="text-subtitle-1">소상공인을 위한 특별한 혜택을 확인해보세요</p>
        </v-col>
        <v-col
          v-for="(benefit, idx) in benefits"
          :key="idx"
          cols="12"
          md="4"
          class="mb-6"
        >
          <v-card class="benefit-card">
            <v-card-title class="justify-center">
              <v-icon large color="primary" class="mr-2">{{ benefit.icon }}</v-icon>
              {{ benefit.title }}
            </v-card-title>
            <v-card-text class="text-center">
              <p class="text-body-1" v-html="benefit.desc"></p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- 대출 조건 섹션 -->
    <div class="loan-section">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center mb-12">
            <h2 class="text-h4 font-weight-bold mb-4">사업자당 최대 3천만원까지</h2>
            <p class="text-subtitle-1">합리적인 조건으로 사업 자금을 마련하세요</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" offset-md="3">
            <v-card class="loan-card">
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-account-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">자격</v-list-item-title>
                    <v-list-item-subtitle>신용점수 500점 이상 소상공인 (현재 연체 보유 및 회생,파산,회복 시 불가)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-cash</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">금액</v-list-item-title>
                    <v-list-item-subtitle>2백만원 ~ 3천만원 (월 매출의 30% 이내)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-percent</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">금리</v-list-item-title>
                    <v-list-item-subtitle>연 12% -> 납부 이자금액의 2~3배 마케팅 인센티브 지급, 결과적으로 마이너스 금리</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-cash-refund</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">펀딩 수수료</v-list-item-title>
                    <v-list-item-subtitle>3% -> 전액 환급</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-calendar-clock</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">상환 방법</v-list-item-title>
                    <v-list-item-subtitle>카드/배달 매출액의 10% 이내의 금액으로 자동 일상환(원리금 상환시까지 평균 3개월, 최대 120일)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- CTA 섹션 -->
    <div class="cta-section">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center">
            <h2 class="text-h4 font-weight-bold mb-4">지금 신청하시고 다양한 혜택 받으세요!</h2>
            <v-btn
              color="white"
              x-large
              class="apply-btn mt-4"
              @click="applyFunding"
            >
              펀딩 신청하기
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WooriCrowdfunding',
  data() {
    return {
      benefits: [
        {
          icon: 'mdi-cash-multiple',
          title: '펀딩수수료 전액 환급',
          desc: '지역/직장/선호지역 투자자 30% 이상 펀딩 참여 조건<br>최소 대출금 중족 시 환급'
        },
        {
          icon: 'mdi-handshake',
          title: '정부 지원 혜택',
          desc: '대출 금액의 4.5% 정부 지원<br>인테리어, 배달포인트, 홍보 비용 등<br>자료 증빙 시 납입하신 이자보다<br>더 많은 혜택을 드립니다'
        },
        {
          icon: 'mdi-chart-line',
          title: '마케팅 효과 UP!',
          desc: '투자자에게 제공되는 리워드로<br>매장 방문을 유도하여<br>적은 비용으로 마케팅 효과를<br>볼 수 있어요'
        }
      ]
    }
  },
  methods: {
    applyFunding() {
      window.open('https://nice-factoring.funda.kr/woori-crowd/intro', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.woori-crowdfunding {
  .hero-section {
    background: linear-gradient(135deg, #1baaf1 0%, #0d8cd6 100%);
    color: white;
    padding: 80px 0;
    margin-bottom: 60px;

    h1 {
      font-size: 2.5rem;
      line-height: 1.2;
    }

    .apply-btn {
      background-color: white !important;
      color: #ffffff !important;
      font-weight: bold;
      padding: 0 40px;
      height: 56px;
      border-radius: 28px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      text-transform: none;
      letter-spacing: 0;
      font-size: 1.1rem;

      &:hover {
        background-color: #f8f9fa !important;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
      }
    }
  }

  .benefits-section {
    padding: 60px 0;

    .benefit-card {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 100%;
      transition: transform 0.3s ease;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: translateY(-5px);
      }

      .v-card__title {
        font-size: 1.25rem;
        padding: 24px 16px 16px;
      }

      .v-card__text {
        padding: 0 16px 24px;
      }
    }
  }

  .loan-section {
    background-color: #f8f9fa;
    padding: 60px 0;

    .loan-card {
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

      .v-list-item {
        padding: 20px 16px;

        &__icon {
          margin-right: 16px;
        }

        &__title {
          font-size: 1.1rem;
          margin-bottom: 4px;
        }

        &__subtitle {
          color: #666;
          line-height: 1.5;
        }
      }
    }
  }

  .cta-section {
    background: linear-gradient(135deg, #1baaf1 0%, #0d8cd6 100%);
    color: white;
    padding: 60px 0;

    .apply-btn {
      background-color: white !important;
      color: #1baaf1 !important;
      font-weight: bold;
      padding: 0 40px;
      height: 56px;
      border-radius: 28px;
    }
  }
}
</style>
